import * as _ from "lodash";
import {Pipe, PipeTransform} from "@angular/core";
import { Carpeta, Archivo } from "../../components/common/utils/entities/util_entity";


@Pipe({
    name: "dataFilter"
})
export class DataFilterNombreArchivo implements PipeTransform {

    transform(array: Archivo[], query: string): any {
        if (query) {
            return _.filter(array, row=> (row.Nombre+"").indexOf((query)) > -1);
        }
        return array;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/formularios/formularios.filter.ts